(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('IncidentSeverity', IncidentSeverity);

    IncidentSeverity.$inject = ['$resource'];

    function IncidentSeverity ($resource) {
        var resourceUrl =  'api/incident-severities/:id';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'byCorporation': {url: 'api/incident-severities/by-corporation/:id', method: 'GET', isArray: true}

        });
    }
})();
